export type Holiday = {
    id: string;
    type_id: string;
    date_start: string;
    date_end: string;
    state_id: HolidayState;
    operator_id: string;
    reason: string | null;
};

export enum HolidayState {
    PENDING = '1',
    ACCEPTED = '2',
    REFUSED = '3',
    CANCELLED = '4'
}

export type GetHolidaysResponse = Holiday[];

export type HolidayType = {
    id: number;
    label: string;
};

export type GetHolidayTypesResponse = HolidayType[];

export type HolidayToCreate = Omit<Holiday, 'id' | 'reason' | 'state_id'>;

export type CreateHolidayPayload = HolidayToCreate;

export type CreateHolidayResponse = {
    success: {
        code: number;
        message: string;
        key: string;
    };
};

export type HolidayToUpdate = Omit<Holiday, 'id'> & { holiday_id: string };

export type UpdateHolidayPayload = HolidayToUpdate;

export type UpdateHolidayResponse = {
    success: {
        code: number;
        message: string;
        key: string;
    };
};

export type DeleteHolidayPayload = {
    holiday_id: string;
};

export type DeleteHolidayResponse = {
    success: {
        code: number;
        message: string;
        key: string;
    };
};
